import React          from 'react'
import ReactDOM       from 'react-dom'
import BaseController from 'controllers/pages/base'
import applyNowWidget from 'widgets/applyNowWidget'
import HomePage from 'containers/HomePage/App'
import MainFooter from 'containers/common/components/MainFooter'
import 'scrollpos-styler/scrollPosStyler.js'
import 'url-search-params-polyfill';

class Controller extends BaseController {
  call() {
    super.call()
    bindResultsFilter.call(this)
    bindNavbarCollapsable.call(this)
    handleIntercom.call(this)

    const domHomePage = document.getElementById('main-page')
    const domMainFooter = document.getElementById('yard-main-footer')
    if (domHomePage) {
      ReactDOM.render(<HomePage />, domHomePage)
    }
    if (domMainFooter) {
      ReactDOM.render(<MainFooter />, domMainFooter)
    }
  }
}

const handleIntercom = function() {
  console.log('URLSearchParams:',URLSearchParams)
  const urlParams = new URLSearchParams(window.location.search)
  console.log('urlParams:',urlParams)
  console.log('hubspotActive:',urlParams.get('hubspotActive'))

  if (urlParams.get('hubspotActive')) {
    if (window.HubSpotConversations) {
      console.log('The api is ready already')
    } else {
      window.hsConversationsOnReady = [
        () => {
          setTimeout(function () {
            window.HubSpotConversations.widget.open()
          }, 1200)
        },
      ];
    }
  }
}

var bindResultsFilter = function() {
  let elem = this.root
  this.applyNowWidget = new applyNowWidget(elem)
}

// This adds/remove the class `navbar-collapsable-show` on the main nav
let bindNavbarCollapsable = function() {
  $('#navbarSupportedContent').on('show.bs.collapse', function () {
    $('.navbar-pages').addClass('navbar-collapsable-show')
  })

  $('#navbarSupportedContent').on('hidden.bs.collapse', function () {
    $('.navbar-pages').removeClass('navbar-collapsable-show')
  })
}



export default Controller
